<body class="ltr  leftmenu" >
    <form autocomplete="off" novalidate [formGroup]="actionForm">
        <div class="card-body pb-0">
            <div class="receipt ">
                <div class="row ">
                    <div class="col-sm-12">
                        <img src="../../assets/images/logo-light.png" class="header-brand-img reciptLogo desktop-logo"
                            alt="logo">
                        <h4 class="mra">{{InstuName}}</h4>
                        <h5 class="mra1">Student Complaint Form</h5>
                    </div>
                </div>
                <div class="row">
                    <div class="receipt-details">
                        <div class="row">
                            <div class="col-sm-6 mt-2 mb-2">
                                <mat-form-field appearance="outline"
                                    class="example-full-width">
                                    <mat-label>Describe your Actions.</mat-label>
                                    <textarea matInput
                                        formControlName="ActionDetails" rows="4"
                                        maxlength="500" 
                                        placeholder="Describe your Actions."
                                        class="form-control"></textarea>
                                    <mat-error *ngIf="actionForm.controls['ActionDetails'].touched && actionForm.controls['ActionDetails'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-6 mt-2 mb-2">
                                <mat-form-field appearance="outline"
                                    class="example-full-width">
                                    <mat-label>Describe your Comments.</mat-label>
                                    <textarea matInput
                                        formControlName="CommentText" rows="4"
                                        maxlength="500" 
                                        placeholder="Describe your Comments."
                                        class="form-control"></textarea>
                                    <mat-error *ngIf="actionForm.controls['CommentText'].touched && actionForm.controls['CommentText'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-6 mt-2 mb-2">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label> Change Status </mat-label>
                                    <mat-select #select593 class="colorblack" formControlName="StatusCode">
                                        <mat-select-filter *ngIf="select593.focused" [placeholder]="'Filter'"
                                            [displayMember]="'CdCode'" [array]="statusList"
                                            (filteredReturn)="filterstatusList =$event"></mat-select-filter>
                                        <mat-option *ngFor="let item of filterstatusList" [value]="item.CdCode">
                                            {{item.CdDesc}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="actionForm.controls['StatusCode'].touched && actionForm.controls['StatusCode'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-sm-6 mt-2 mb-2" *ngIf="actionFormArray['Publish'][0]['FormVisible']">
                                <mat-label>{{actionFormArray['Publish'][0]['FormDisplayName']}}
                                    <span *ngIf="actionFormArray['Publish'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-radio-group formControlName="Publish" class="example-full-width">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                                        </div>
                                        <div class="col-sm-6">
                                            <mat-radio-button [value]="false">No</mat-radio-button>
                                        </div>
                                    </div>
                                    
                                </mat-radio-group>
                                <mat-error class='aline' *ngIf="actionForm.controls['Publish'].touched && actionForm.controls['Publish'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </div>
                            
                        </div>
                    </div>

                </div>
                <button type="button"  *ngIf="submitButton" class="btn btn-primary btn-icon-text floatright fr sz mt-2" (click)="Save()" >
                    <span style="display: contents; align-items: center;">
                        <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                        Save
                    </span>
                </button>
                <button id="Back" type="button" [mat-dialog-close]="true"
                    class="btn btn-primary btn-icon-text floatright mt-2">
                    <span style="display: contents; align-items: center;">
                        <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                        Back
                    </span>
                </button>
            </div>
        </div>
    </form>
</body>